import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-252fd550"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "list" }
const _hoisted_2 = { class: "date c-thirdary" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "point" }, null, -1))
const _hoisted_4 = { class: "text c-secondary" }
const _hoisted_5 = ["innerHTML"]

import news, { State } from '@/store/mine/news';
import * as filters from '@/views/filters';
import { computed } from 'vue';
import { useStore } from 'vuex';

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const store = useStore();
const data = computed<State>(() => store.state[news.name])

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(data).list, (item, i) => {
      return (_openBlock(), _createElementBlock("div", {
        class: "item",
        key: i
      }, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createTextVNode(" " + _toDisplayString(_unref(filters).date(item.create_time)), 1)
        ]),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", {
            class: "html",
            innerHTML: item.content
          }, null, 8, _hoisted_5)
        ])
      ]))
    }), 128))
  ]))
}
}

})